import React from "react";
import { Input } from "./Input";
import { TooltipAndScale } from "./TooltipAndScale";
import { showRulers } from "./RangeSlider.utils";
import PropTypes from "prop-types";
import style from "./style.module.scss";

const wrapRef = React.createRef(null);
/**
 * RangeSlider
 *  - General Range Slider with few cusomizations
 *  - Passing in positive step value and scaleInterval value to slider displays tooltip and ruler
 */
export function RangeSlider(props) {
  const [show, toggleShow] = React.useState(true);

  // On initial render the ruler is not displayed by default as wrapRef is null
  // The state change cause a manual re-render which display the ruler
  React.useEffect(() => toggleShow(false), []);

  if (showRulers(props.scaleInterval)) {
    const onMouseEvent = (value) => () => toggleShow(value);
    return (
      <div
        ref={wrapRef}
        style={{ minHeight: "52px" }}
        onMouseEnter={onMouseEvent(true)}
        onMouseLeave={onMouseEvent(false)}
        className={`${style.wrap} ${props.className}`}
      >
        <TooltipAndScale
          show={show}
          min={props.min}
          max={props.max}
          unit={props.unit}
          scaleInterval={props.scaleInterval}
          wrapRef={wrapRef}
          value={props.value}
        >
          <Input
            labelledby={props.labelledby}
            min={props.min}
            max={props.max}
            prevAria={props.prevAria}
            nextAria={props.nextAria}
            step={props.step}
            keyboardStep={props.keyboardStep}
            value={props.value}
            onChange={props.onChange}
            inputLabel={props.inputLabel}
            cusomizations={props.customThumb}
            altTextData={props.altTextData}
            ariaInterval={props.ariaInterval}
            ariaLabel={props.ariaLabel}
          />
        </TooltipAndScale>
      </div>
    );
  } else {
    return (
      <div
        style={{ height: "12px" }}
        className={`${style.wrap} ${props.className}`}
      >
        <Input
          labelledby={props.labelledby}
          min={props.min}
          max={props.max}
          prevAria={props.prevAria}
          nextAria={props.nextAria}
          step={props.step}
          keyboardStep={props.keyboardStep}
          value={props.value}
          onChange={props.onChange}
          inputLabel={props.inputLabel}
          cusomizations={props.customThumb}
          altTextData={props.altTextData}
          ariaInterval={props.ariaInterval}
          ariaLabel={props.ariaLabel}
        />
      </div>
    );
  }
}

RangeSlider.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Scale interval to display rulers
   */
  scaleInterval: PropTypes.number,
  /**
   * The unit for the scale value
   */
  unit: PropTypes.string,
  ariaLabel: PropTypes.string,

  nextAria: PropTypes.object,
  prevAria: PropTypes.object,
  ...Input.propTypes,
};

RangeSlider.defaultProps = {
  scaleInterval: undefined,
  unit: "",
};
